<app-topbar
  [isMobileViewport]="isMobileViewport"
  [isSidebarOpen]="isSidebarOpen"
  (mobileMenuButtonClicked)="onToggleMobileMenu()"
></app-topbar>

<app-sidebar
  (overlayClicked)="closeSidebar()"
  (mobileNavigationRequested)="closeSidebar()"
></app-sidebar>

<div class="page-wrapper">
  <div class="page-content">
    <div class="container-fluid page-content-container">
      <router-outlet />
    </div>
    <app-footer />
  </div>
</div>
